import type { WeddingEvent, EventStatus } from '@/lib/types';
import { SectionDivider } from './SectionDivider';
import { EventRow } from './EventRow';

interface EventListProps {
  events: WeddingEvent[];
  onDelete: (eventId: string) => void;
  onStatusChange: (eventId: string, status: EventStatus) => void;
  onEdit: (eventId: string) => void;
}

export function EventList({ events, onDelete, onStatusChange, onEdit }: EventListProps) {
  // Group events by time block
  const morning = events.filter((e) => new Date(e.startTime).getHours() < 12);
  const afternoon = events.filter((e) => {
    const h = new Date(e.startTime).getHours();
    return h >= 12 && h < 17;
  });
  const evening = events.filter((e) => new Date(e.startTime).getHours() >= 17);

  const renderGroup = (label: string, groupEvents: WeddingEvent[]) => {
    if (groupEvents.length === 0) return null;
    return (
      <div key={label}>
        <SectionDivider label={label} />
        {groupEvents.map((event) => (
          <EventRow
            key={event.id}
            event={event}
            onDelete={onDelete}
            onStatusChange={onStatusChange}
            onEdit={onEdit}
          />
        ))}
      </div>
    );
  };

  return (
    <div>
      {renderGroup('Morning', morning)}
      {renderGroup('Afternoon', afternoon)}
      {renderGroup('Evening', evening)}
    </div>
  );
}
